// extracted by mini-css-extract-plugin
export var fadeIn = "_jo-1";
export var modalContent = "_jo-3";
export var overlay = "_jo-0";
export var popoverContent = "_jo-2";
export var results = "_jo-5";
export var searchInputWrapper = "_jo-4";